<template>
    <div
        class="relative overflow-y-auto pl-0 pr-0 font-proregular md:w-1/5 md:pl-2 md:pr-4 2xl:mr-4 2xl:pl-0"
    >
        <div class="relative grid grid-cols-1">
            <div class="sticky top-0 z-20 border-b border-black-text bg-white">
                <div class="page-title pt-2 2xl:pt-0">
                    {{
                        useLocaleValue(
                            store.getPageInfo("mapy-katalog-lokalit"),
                            "title"
                        )
                    }}
                </div>
                <div class="absolute right-0 top-2">
                    <div v-tooltip:right="$t('klok.tooltip_description')">
                        <Icon
                            name="custom:info"
                            class="text-xl"
                        />
                    </div>
                </div>
                <KlokSearchBar />
                <div class="relative mb-4 flex flex-col text-sm">
                    <div
                        v-show="klokStore.selectedLocality"
                        class="absolute right-0 top-0 flex items-center justify-end gap-2"
                    >
                        <div
                            v-tooltip:right="
                                $t('general.tooltip_download_data')
                            "
                            class="cursor-pointer"
                            @click="downloadLocalityData"
                        >
                            <Icon name="custom:stahovani" />
                        </div>
                        <div
                            v-tooltip:right="$t('general.close')"
                            class="cursor-pointer"
                            @click="
                                () => {
                                    klokStore.selectedLocality = null
                                    klokStore.mode = 'mesto'
                                    store.mobileLeftPanelOpen = false
                                }
                            "
                        >
                            <Icon name="custom:close" />
                        </div>
                    </div>
                    <div
                        v-for="metrika in klokStore.settings?.metriky.slice(
                            0,
                            6
                        )"
                        :key="metrika.PORADI"
                        :class="{
                            'font-promedium underline':
                                klokStore.selectedMetrika?.NAZEV_UDAJE_DATA ===
                                metrika.NAZEV_UDAJE_DATA,
                            'cursor-pointer hover:underline':
                                metrika.NAZEV_UDAJE_DATA !== 'CISLO' &&
                                metrika.NAZEV_UDAJE_DATA !== 'NAZEV',
                        }"
                        @click="handleMetrikaClick(metrika)"
                    >
                        {{ useLocaleValue(metrika, "NAZEV_UDAJE") }}:
                        <span class="font-promedium">{{
                            klokStore.selectedLocality
                                ? getValue(
                                      metrika.NAZEV_UDAJE_DATA,
                                      klokStore.selectedLocality?.[
                                          metrika.NAZEV_UDAJE_DATA
                                      ],
                                      locale as LanguageCode
                                  )
                                : ""
                        }}</span>
                    </div>
                    <!-- <KlokMetrikaItem
                                        v-for="metrika in metriky.slice(0, 6)"
                                        :key="metrika.PORADI"
                                        :item="metrika"
                                    /> -->
                </div>
            </div>
            <div class="">
                <div
                    v-if="klokStore.settings"
                    class="mt-4 grid auto-cols-max grid-cols-2 items-stretch justify-items-stretch gap-2 overflow-y-auto 2xl:grid-cols-3"
                >
                    <KlokMetrikaItem
                        v-for="metrika in klokStore.settings.metriky.slice(
                            6,
                            12
                        )"
                        :key="metrika.PORADI"
                        :item="metrika"
                    />
                    <KlokDonutMetrikaItem
                        :metriky="klokStore.settings.metriky.slice(12, 17)"
                    />
                    <KlokMetrikaItem
                        v-for="metrika in klokStore.settings.metriky.slice(
                            17,
                            23
                        )"
                        :key="metrika.PORADI"
                        :item="metrika"
                    />
                    <KlokDonutMetrikaItem
                        :metriky="klokStore.settings.metriky.slice(23)"
                    />
                    <div class="h-10" />
                </div>
            </div>
        </div>
        <!-- <div class="bg-white px-4">
                            <KlokSearchWidget v-if="klokStore.viewReady" />
                        </div> -->
    </div>
</template>

<script lang="ts" setup>
import * as XLSX from "xlsx"

const store = useMainStore()
const klokStore = useKlokStore()
const { locale } = useI18n()

const { getValue } = useKlokDictionaries()

function handleMetrikaClick(metrika: KlokMetrikaItem) {
    if (
        metrika.NAZEV_UDAJE_DATA === "CISLO" ||
        metrika.NAZEV_UDAJE_DATA === "NAZEV"
    ) {
        return
    }
    if (
        klokStore.selectedMetrika?.NAZEV_UDAJE_DATA === metrika.NAZEV_UDAJE_DATA
    ) {
        klokStore.selectedMetrika = null
        return
    }
    klokStore.selectedMetrika = metrika
    store.mobileLeftPanelOpen = false
}

function downloadLocalityData() {
    if (!klokStore.selectedLocality) return
    const header = [
        "Kód metriky",
        "Název metriky",
        "Hodnota",
        "Jednotka",
        "Anotace",
    ]
    const rows = []
    rows.push(header)
    klokStore.settings?.metriky.forEach((metrika, idx) => {
        if (idx < 6) {
            rows.push([
                metrika.NAZEV_UDAJE_DATA,
                useLocaleValue(metrika, "NAZEV_UDAJE"),
                getValue(
                    metrika.NAZEV_UDAJE_DATA,
                    klokStore.selectedLocality?.[metrika.NAZEV_UDAJE_DATA],
                    locale.value as LanguageCode
                ) || "",
                useLocaleValue(metrika, "JEDNOTKA_ZOBRAZ") || "",
                useLocaleValue(metrika, "ANOTACE") || "",
            ])
        } else {
            if (metrika.NAZEV_UDAJE_DATA.includes(",")) {
                rows.push([
                    metrika.NAZEV_UDAJE_DATA.split(",")[0],
                    useLocaleValue(metrika, "NAZEV_UDAJE"),
                    klokStore.selectedLocality?.[
                        metrika.NAZEV_UDAJE_DATA.split(",")[0] as string
                    ] || "",
                    useLocaleValue(metrika, "JEDNOTKA_ZOBRAZ").split(",")[0] ||
                        "",
                    useLocaleValue(metrika, "ANOTACE") || "",
                ])
            } else {
                rows.push([
                    metrika.NAZEV_UDAJE_DATA,
                    useLocaleValue(metrika, "NAZEV_UDAJE"),
                    klokStore.selectedLocality?.[metrika.NAZEV_UDAJE_DATA] ||
                        "",
                    useLocaleValue(metrika, "JEDNOTKA_ZOBRAZ") || "",
                    useLocaleValue(metrika, "ANOTACE") || "",
                ])
            }
        }
    })
    const worksheet = XLSX.utils.aoa_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data")
    XLSX.writeFile(
        workbook,
        `${useLocaleValue(
            store.getPageInfo("mapy-katalog-lokalit"),
            "title"
        )}: ${klokStore.selectedLocality.NAZEV}.xlsx`
    )
}
</script>

<style scoped></style>
